import { Drawer } from "@components";
import { Titles } from "../../variables/Titles";

import FixedValueForm from "../types/FixedValueForm";

export const CouponTypeForm = ({
  visible,
  onClose,
  node,
  onChange,
  onSave,
  onRemove,
}) => {
  const options = [
    { label: "Desconto em R$", value: "CASH_DISCOUNT" },
    { label: "Desconto em %", value: "PERCENTAGE_DISCOUNT" },
    { label: "Entrega grátis", value: "FREE_DELIVERY" },
    { label: "Cashback", value: "CASHBACK" },
    { label: "Produto", value: "PRODUCT_DISCOUNT" },
  ];

  return (
    <Drawer
      visible={visible}
      onClose={() => onClose()}
      title={Titles.CouponType}
      direction="center-right"
      parentSelector={() => document.getElementById("oracle-flow")}
    >
      <FixedValueForm
        node={node}
        options={options}
        onSave={(node) => onSave(node)}
        onRemove={onRemove}
      />
    </Drawer>
  );
};
